import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
//
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import CategoryPage from './pages/CategoryPage';
import CategoryStorePage from './pages/CategoryStorePage';
import PostPage from './pages/PostPage';
import PostStorePage from './pages/PostStorePage';
import Protected from './gurd/Protected';
import SettingPage from './pages/SettingPage';
import CommentsPage from './pages/CommentsPage';
import SubscriberPage from './pages/SubscriberPage';
import ContactsPage from './pages/ContactsPage';

// ----------------------------------------------------------------------

export default function Router() {


  
  const routes = useRoutes([
    {
      path: 'login',
      element: (
          <LoginPage  />
      ),
    },
    {
      path: '/dashboard',
      element:(
          <Protected Component={DashboardLayout} ></Protected>
        )
      ,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'category', element: <CategoryPage /> },
        { path: 'posts', element: <PostPage /> },
        { path: 'posts/store', element: <PostStorePage /> },
        { path: 'category/store', element: <CategoryStorePage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'comments', element: <CommentsPage /> },
        { path: 'subscribers', element: <SubscriberPage /> },
        { path: 'contacts', element: <ContactsPage /> },
        { path: 'setting', element: <SettingPage /> },
        
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
